<template>
  <!-- Añadir el modal al inicio -->
  <transition name="fade">
    <div v-if="showModal" class="warranty-modal">
      <div class="modal-backdrop" @click="closeModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="fw-bold mb-0">Información Importante</h3>
          <button class="close-btn" @click="closeModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="info-item">
            <div class="info-icon warning">
              <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div class="info-text">
              <h4>NO se reponen plantines</h4>
              <p>Esta garantía solo cubre la germinación inicial de las semillas.</p>
            </div>
          </div>
          <div class="info-item">
            <div class="info-icon">
              <i class="fas fa-camera"></i>
            </div>
            <div class="info-text">
              <h4>Documenta el proceso</h4>
              <p>Toma fotos del proceso y conserva el blíster original.</p>
            </div>
          </div>
          <div class="info-item">
            <div class="info-icon">
              <i class="fas fa-calendar-check"></i>
            </div>
            <div class="info-text">
              <h4>Registra las fechas</h4>
              <p>Anota la fecha de inicio del proceso de germinación.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex gap-3 w-100">
            <button class="btn btn-primary flex-grow-1" @click="closeModal">
              Entendido, continuar
            </button>
            <router-link to="/garantia" class="btn btn-outline-light flex-grow-1">
              <i class="fas fa-shield-alt me-2"></i>Pedir garantia
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <section class="container-fluid mt-5 py-5">
    <div class="container mt-5 px-3">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <h1 class="text-center text-light mb-5 display-5 fw-bold">
            Guía de Germinación
            <i class="fas fa-seedling text-primary ms-3 animate__animated animate__bounceIn"></i>
          </h1>

          <!-- Timeline existente -->
          <div class="timeline">
            <!-- Step 1 -->
            <div class="timeline-item">
              <div class="timeline-badge">
                <i class="fas fa-temperature-low"></i>
              </div>
              <div class="card bg-dark text-light hover-card">
                <div class="card-body">
                  <h3 class="text-primary mb-4">1. Aclimatación</h3>
                  <div class="step-content">
                    <p class="mb-3">Deja las semillas 24-48 horas a temperatura ambiente antes de comenzar, ya que las semillas se conservan bajo refrigeración.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 2 -->
            <div class="timeline-item">
              <div class="timeline-badge">
                <i class="fas fa-glass-whiskey"></i>
              </div>
              <div class="card bg-dark text-light hover-card">
                <div class="card-body">
                  <h3 class="text-primary mb-4">2. Preparación del Agua</h3>
                  <div class="step-content">
                    <ul class="list-unstyled">
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-check-circle text-success me-3"></i>
                        Usa un vaso limpio con agua declorada hasta la mitad
                      </li>
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-check-circle text-success me-3"></i>
                        Agrega 2-3 gotas de agua oxigenada
                      </li>
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-thermometer-half text-success me-3"></i>
                        Mantén temperatura entre 20° y 25°C
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 3 -->
            <div class="timeline-item">
              <div class="timeline-badge">
                <i class="fas fa-tint"></i>
              </div>
              <div class="card bg-dark text-light hover-card">
                <div class="card-body">
                  <h3 class="text-primary mb-4">3. Proceso de Germinación</h3>
                  <div class="step-content">
                    <p>Sumerge las semillas durante 24-72 horas hasta que partan.</p>
                    <div class="alert alert-info mb-3 text-white-50 fw-light">
                      <i class="fas fa-lightbulb me-2"></i>
                      <strong>Método alternativo:</strong> Puedes usar el "método plato volador" con servilletas, pero primero sumerge las semillas 24hs en agua preparada
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Step 4 -->
            <div class="timeline-item">
              <div class="timeline-badge">
                <i class="fas fa-spa"></i>
              </div>
              <div class="card bg-dark text-light hover-card">
                <div class="card-body">
                  <h3 class="text-primary mb-4">4. Transplante</h3>
                  <div class="step-content">
                    <ul class="list-unstyled">
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-check-circle text-success me-3"></i>
                        Al ver la punta de la raíz, coloca la semilla de 1 a 2 centimetros de profundidad
                      </li>
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-check-circle text-success me-3"></i>
                        Posiciona la raíz hacia abajo
                      </li>
                      <li class="mb-3 d-flex align-items-center">
                        <i class="fas fa-check-circle text-success me-3"></i>
                        Riega suavemente para humedecer el sustrato
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Call to action -->
          <div class="text-center mt-5 pt-4">
            <p class="text-light fs-4 mb-4">¿Listo para empezar?</p>
            <div class="d-flex gap-3 justify-content-center">
              <a href="/productos" class="btn btn-primary btn-lg">
                <i class="fas fa-shopping-cart me-2"></i>
                Comprar Semillas
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';

const showModal = ref(true);

const closeModal = () => {
  showModal.value = false;
};

onMounted(() => {
  document.body.style.overflow = 'hidden';
});

onUnmounted(() => {
  // Asegurar que el scroll se restaure al salir del componente
  document.body.style.overflow = 'auto';
});

watch(showModal, (newValue) => {
  document.body.style.overflow = newValue ? 'hidden' : 'auto';
});
</script>

<style scoped>

.timeline {
  position: relative;
  padding: 20px 0;
}

.timeline:before {
  content: '';
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 3px; /* Línea más gruesa */
  background: linear-gradient(
    to bottom,
    transparent,
    var(--primary-color) 5%,
    var(--primary-color) 95%,
    transparent
  );
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(var(--primary-color-rgb), 0.3);
}

.timeline-item {
  position: relative;
  margin-bottom: 50px;
  padding-left: 60px; /* Más espacio para la línea */
}

.timeline-badge {
  position: absolute;
  left: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--black-color-2);
  border: 3px solid var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  z-index: 2;
  box-shadow: 0 0 0 4px rgba(var(--primary-color-rgb), 0.2),
              0 0 15px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.timeline-item:hover .timeline-badge {
  transform: scale(1.1);
  box-shadow: 0 0 0 6px rgba(var(--primary-color-rgb), 0.2),
              0 0 20px rgba(0, 0, 0, 0.6);
}

.hover-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(
    145deg,
    var(--black-color-2) 0%,
    var(--black-color-3) 100%
  );
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.hover-card:hover {
  transform: translateX(5px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  border-color: rgba(var(--primary-color-rgb), 0.3);
}

.step-content {
  padding: 1.5rem;
  background: var(--black-color-2);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* Ajuste responsive */
@media (max-width: 768px) {
  .timeline:before {
    left: 17px;
    width: 2px;
  }

  .timeline-item {
    padding-left: 45px;
  }

  .timeline-badge {
    width: 36px;
    height: 36px;
    font-size: 0.9rem;
  }
}

.success-indicator {
  display: inline-block;
  padding: 8px 16px;
  background: rgba(25, 135, 84, 0.1);
  border-radius: 20px;
  color: #198754;
}

.step-content {
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.alert {
  border: none;
  border-left: 4px solid;
  background: rgba(255, 255, 255, 0.05);
}

.alert-info {
  background: rgba(13, 202, 240, 0.1);
  border-left-color: var(--bs-info);
}

.alert-warning {
  background: rgba(255, 193, 7, 0.1);
  border-left-color: var(--bs-warning);
}

.warranty-card {
  background: linear-gradient(145deg, #1a1a1a 0%, #2c2c2c 100%);
  border-width: 2px !important;
}

.success-text {
  color: #28a745;
  font-size: 1.2rem;
  font-weight: 600;
}

.important-notice .card {
  background: linear-gradient(145deg, var(--black-color-2) 0%, var(--black-color-3) 100%);
  border: 1px solid rgba(255, 193, 7, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.important-list li {
  padding: 1rem;
  margin-bottom: 0.5rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.important-list li:hover {
  transform: translateX(5px);
  background: rgba(0, 0, 0, 0.3);
}

.important-list i {
  font-size: 1.25rem;
  width: 30px;
}

/* Mejoras para impresión */
@media print {
  .timeline-badge {
    border: 2px solid var(--primary-color);
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  .important-notice {
    break-inside: avoid;
  }
  
  .btn {
    display: none;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .important-list li {
    font-size: 1rem;
    padding: 0.75rem;
  }
  
  .timeline-item {
    margin-bottom: 2rem;
  }
}

.warranty-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 500px;
  background: var(--black-color-2);
  border-radius: 16px;
  z-index: 1051;
  overflow: hidden;
}

.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: var(--white-color-2);
  font-size: 1.25rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  color: var(--white-color);
  transform: scale(1.1);
}

.modal-body {
  padding: 1.5rem;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.05);
}

.info-item:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateX(5px);
}

.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color);
  color: white;
  font-size: 1.2rem;
}

.info-icon.warning {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
}

.info-text {
  flex: 1;
}

.info-text h4 {
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
  color: var(--white-color);
}

.info-text p {
  font-size: 0.9rem;
  margin: 0;
  color: var(--white-color-2);
}

.modal-footer {
  padding: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Animaciones */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Ajustes responsivos */
@media (max-width: 768px) {
  .modal-content {
    margin: 1rem;
  }
  
  .info-item {
    padding: 0.75rem;
  }
  
  .info-text h4 {
    font-size: 1rem;
  }
  
  .info-text p {
    font-size: 0.85rem;
  }
}
</style>